# frozen_string_literal: true

module Engine
  module Game
    module G1822PnwShort
    end
  end
end
